// @flow

import {isBrowser} from 'docs/util';

declare var __webpack_public_path__: string;

if (isBrowser) {
  __webpack_public_path__ = window.__INITIAL_STATE__.baseUrlAssets;
}
